import { render, staticRenderFns } from "./OperacionesViewProductosDetalle.vue?vue&type=template&id=eb488cb6&"
import script from "./OperacionesViewProductosDetalle.vue?vue&type=script&lang=js&"
export * from "./OperacionesViewProductosDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports